import React from 'react';
import { Box, Typography, List, ListItem, ListItemText, Paper, Grid } from '@mui/material';
import { differenceInCalendarDays, parseISO, format, isFuture, isToday } from 'date-fns';

interface Holiday {
  name: string;
  date: string; // ISO format YYYY-MM-DD
}

const nzPublicHolidays2025: Holiday[] = [
  { name: "New Year's Day", date: '2025-01-01' },
  { name: 'Day after New Year\'s Day', date: '2025-01-02' },
  { name: 'Waitangi Day', date: '2025-02-06' },
  { name: 'Good Friday', date: '2025-04-18' },
  { name: 'Easter Monday', date: '2025-04-21' },
  { name: 'ANZAC Day', date: '2025-04-25' },
  { name: "King's Birthday", date: '2025-06-02' },
  { name: 'Matariki', date: '2025-06-20' },
  { name: 'Labour Day', date: '2025-10-27' },
  { name: 'Christmas Day', date: '2025-12-25' },
  { name: 'Boxing Day', date: '2025-12-26' },
];

const NzPublicHolidays: React.FC = () => {
  const today = new Date(); // Use current date for calculation

  const upcomingHolidays = nzPublicHolidays2025
    .map(holiday => ({
      ...holiday,
      parsedDate: parseISO(holiday.date),
    }))
    .filter(holiday => isFuture(holiday.parsedDate) || isToday(holiday.parsedDate))
    .sort((a, b) => a.parsedDate.getTime() - b.parsedDate.getTime());

  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom component="h2">
        NZ Public Holidays 2025
      </Typography>
      <List>
        {upcomingHolidays.length > 0 ? (
          upcomingHolidays.map((holiday) => {
            const daysToGo = differenceInCalendarDays(holiday.parsedDate, today);
            let daysToGoText = '';
            if (daysToGo === 0) {
              daysToGoText = 'Today';
            } else if (daysToGo === 1) {
              daysToGoText = 'Tomorrow';
            } else {
              daysToGoText = `${daysToGo} days to go`;
            }

            return (
              <ListItem key={holiday.name} divider>
                <Grid container justifyContent="space-between" alignItems="center">
                  <Grid item>
                    <ListItemText 
                      primary={holiday.name} 
                      secondary={format(holiday.parsedDate, 'EEEE, d MMMM yyyy')} 
                    />
                  </Grid>
                  <Grid item>
                    <Typography variant="body2" color="primary">
                      {daysToGoText}
                    </Typography>
                  </Grid>
                </Grid>
              </ListItem>
            );
          })
        ) : (
          <ListItem>
            <ListItemText primary="No upcoming public holidays for 2025 from today." />
          </ListItem>
        )}
      </List>
    </Paper>
  );
};

export default NzPublicHolidays;
